module.exports = __webpack_public_path__ + "img/main_logo_w.4a20fe10.png";